export default {
  "brand.name": "barewitness films",
  "brand.tagline": "San Francisco Bay Area",

  "nav.home": "Home",
  "nav.about": "About",
  "nav.films": "Films",
  "nav.players": "Players",
  "nav.news": "News",
  "nav.contact": "Contact",
  "nav.menu": "Menu",
  "nav.close": "Close",
  "nav.searchPlaceholder": "Search the site",
  "nav.search": "Search",
  "nav.donate": "Donate",

  "hero.kicker": "Independent Filmmaking",
  "hero.title": "We make films the bare way — no fuss, just witness.",
  "hero.subtitle":
    "A San Francisco Bay Area collective of actors, writers, and shooters telling small, honest stories on whatever we can carry.",
  "hero.ctaPrimary": "Explore Our Films",
  "hero.ctaSecondary": "Support the Work",
  "hero.scroll": "Scroll to explore",

  "about.kicker": "Who We Are",
  "about.title": "A small collective with a big love of the craft",
  "about.body":
    "barewitness films came together in the Bay Area around a simple idea: gather good people, point a camera at them, and get out of the way. We shoot fast, we shoot cheap, and we keep coming back for more.",
  "about.body2":
    "From festival shorts to behind-the-scenes diaries and stage projects, everything we make is built by the same core group — the players you’ll meet further down the page.",
  "about.pointOne": "Written, shot, and edited in-house",
  "about.pointTwo": "Bay Area locations and Bay Area people",
  "about.pointThree": "Festival shorts, docs, and stage work",

  "films.kicker": "Selected Work",
  "films.title": "Films",
  "films.subtitle":
    "A handful of the shorts, docs, and festival entries we’ve shaped together.",
  "films.runtime": "Runtime",
  "films.viewAll": "View the full filmography",

  "players.kicker": "The Company",
  "players.title": "Players",
  "players.subtitle":
    "The core group behind every shoot — in front of the lens and behind it.",

  "news.kicker": "From the Set",
  "news.title": "News Archive",
  "news.subtitle": "Festival news, new releases, and notes from production.",
  "news.readMore": "Read the story",

  "support.kicker": "Keep Us Rolling",
  "support.title": "Independent film runs on people like you",
  "support.body":
    "Every donation goes straight into gear, locations, and the small costs that add up on set. It keeps the collective shooting instead of fundraising.",
  "support.cta": "Support barewitness films",
  "support.note": "Donations are arranged directly — reach out and we’ll get you sorted.",

  "contact.kicker": "Say Hello",
  "contact.title": "Contact",
  "contact.subtitle":
    "Press, collaborations, casting, or just a kind word — we read everything.",
  "contact.locationLabel": "Based in",
  "contact.locationValue": "San Francisco Bay Area, California",
  "contact.emailLabel": "Email",
  "contact.emailValue": "hello@barewitness.com",

  "form.name": "Name",
  "form.namePlaceholder": "Your name",
  "form.email": "Email",
  "form.emailPlaceholder": "you@example.com",
  "form.subject": "Subject",
  "form.subjectGeneral": "General question",
  "form.subjectPress": "Press & festivals",
  "form.subjectCollab": "Collaboration",
  "form.subjectDonate": "Donations & support",
  "form.message": "Message",
  "form.messagePlaceholder": "Tell us what’s on your mind…",
  "form.submit": "Send message",
  "form.sending": "Sending…",
  "form.success": "Thanks — your message is on its way. We’ll be in touch soon.",
  "form.error": "Something went wrong sending your message. Please try again.",
  "form.required": "Please fill in your name, email, and a message.",

  "footer.about":
    "An independent filmmaking collective in the San Francisco Bay Area.",
  "footer.explore": "Explore",
  "footer.more": "More",
  "footer.morePlaydates": "Playdates",
  "footer.moreStage": "Stage",
  "footer.moreFriends": "Friends",
  "footer.moreHotLinks": "Hot Links",
  "footer.follow": "Follow",
  "footer.rights": "© 2013 Barewitness Films, Inc. Rebuilt and maintained with care.",
  "footer.credit": "Made in the Bay Area",
};